
import { Employee } from "domain/entities/employee";
import { Parameter } from "domain/entities/parameter";
import { EmployeeInputFilter } from "domain/models/employee-input-filter";
import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import { useEmployeesByFilter } from "presentation/hooks/use-query-employees";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import "../index.css";
import ExpenseGrid from "../ExpenseGrid";

interface ExpenseAdminParams {
  date: Date;
  employee: Employee;
}

const ExpenseAdmin: React.FC = () => {
  const toast = useRef<Toast>(null);

  const { data: employeesData, refetch: refetchEmployees } = useEmployeesByFilter({ limit: 100, isActive: true } as EmployeeInputFilter); // removed justCPS: true as it might not be relevant for expenses
  const [employees, setEmployees] = useState<Parameter[]>();
  const [expenseAdminParameters, setExpenseAdminParameters] =
    useState<ExpenseAdminParams>();

  const [employeeToAnalyse, setEmployeeToAnalyse] = useState<Parameter>();

  useEffect(() => {
    const formatedEmployees = employeesData?.data?.map((item) => {
      const employee: Parameter = {
        id: item.id,
        value: item.name,
        type: "employee",
      };
      return employee;
    });

    const allEmployeesOption: Parameter = {
      id: "todos",
      value: "TODOS",
      type: "employee",
    };

    setEmployees([allEmployeesOption, ...(formatedEmployees ?? [])]);
  }, [employeesData]);

  useEffect(() => {
    if (expenseAdminParameters?.employee) {
      const empToAnalyse: Parameter = {
        id: expenseAdminParameters.employee.id,
        value: expenseAdminParameters.employee.name,
        type: "employee",
      };
      setEmployeeToAnalyse(empToAnalyse);
    }
  }, [expenseAdminParameters?.employee]);

  return (
    <div className="default-grid ">
      <div className="default-2-cols">
        <DropdownComponent
          options={employees ?? []}
          label="Colaborador"
          isValueId={true}
          fieldName="employee"
          currentObject={expenseAdminParameters}
          getValue={expenseAdminParameters?.employee?.id || null}
          setValue={setExpenseAdminParameters}
        />
      </div>

      <div className="default-1-col">
        <InputDateComponent
          label="Data"
          fieldName="date"
          currentObject={expenseAdminParameters}
          getValue={expenseAdminParameters?.date}
          setValue={setExpenseAdminParameters}
          view="month"
          dateFormat="yy/mm"
        />
      </div>


      <div className="default-4-cols">
        {expenseAdminParameters?.employee &&
          expenseAdminParameters?.date &&
          expenseAdminParameters?.employee.id.toLowerCase() !== "todos" && (
            <ExpenseGrid
              externalFilters={{
                employeeId: employeeToAnalyse?.id ?? "",
                month: expenseAdminParameters.date.getMonth() + 1,
                year: expenseAdminParameters.date.getFullYear(),
                sortBy: "createdAt",
                sortOrder: "desc",
              }}
              hideAddExpense={true}
            />
          )}

        {expenseAdminParameters?.employee &&
          expenseAdminParameters?.date &&
          expenseAdminParameters?.employee.id.toLowerCase() === "todos" && (
            <ExpenseGrid
              externalFilters={{
                month: expenseAdminParameters.date.getMonth() + 1,
                year: expenseAdminParameters.date.getFullYear(),
                employeeId: "*",
                sortBy: "employee.name",
                sortOrder: "asc",
              }}
              hideAddExpense={true}
            />
          )}
      </div>

      <Toast ref={toast} position="bottom-right" />

    </div>
  );
};
export default ExpenseAdmin;
